const parseJsonObject = <T extends Record<any, any>>(
  jsonString: string | undefined | null
): T | Record<string, never> => {
  if (!jsonString) {
    return {};
  }

  try {
    const parsed = JSON.parse(jsonString);

    // Check if the parsed value is an object and not null (typeof null is "object")
    if (parsed && typeof parsed === "object" && !Array.isArray(parsed)) {
      return parsed as T;
    } else {
      return {};
    }
  } catch (e) {
    // If JSON.parse throws an error, the input was not valid JSON
    return {};
  }
};

// Types for the result object with discriminated union
type Success<T> = {
  data: T;
  error: null;
};

type Failure<E> = {
  data: null;
  error: E;
};

type Result<T, E = Error> = Success<T> | Failure<E>;

// Main wrapper function
async function tryCatch<T, E = Error>(promise: Promise<T>): Promise<Result<T, E>> {
  try {
    const data = await promise;
    return { data, error: null };
  } catch (error) {
    return { data: null, error: error as E };
  }
}

export { parseJsonObject, tryCatch };
